const Augl = (target) => {
  const modal = document.querySelector(".modal");
  const modalContainer = modal.querySelector(".container") as HTMLElement;
  const iframe = modal.querySelector("iframe");
  const videoId = target.getAttribute("data-vidid");
  const aspectRatio = (16 / 9);

  const method = {
    init: () => {
      target.addEventListener("click", method.open);
      window.addEventListener("resize", method.resize);
      window.addEventListener("load", method.resize);
    },
    resize: () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      if (windowHeight < windowWidth) {
        const preferredNewWidth = (windowHeight - 180) * aspectRatio;
        const newContainerWidth = preferredNewWidth > windowWidth ? windowWidth : preferredNewWidth;

        modalContainer.setAttribute("style", `width:${newContainerWidth}px`);
      } else {
        modalContainer.setAttribute("style", "width:100%");
      }
    },
    open: () => {
      let videoSrc = iframe.getAttribute("data-src");
      videoSrc = videoSrc.replace("VIDID", videoId);
      iframe.src = videoSrc;
      modal.classList.add("modal--open");
    },
  };

  method.init();
};

export default Augl;
